import { cx } from '@emotion/css';
import type { FC, HTMLProps } from 'react';

export interface ODSContainerProps extends HTMLProps<HTMLDivElement> {
  /** Make the container [fluid](https://getbootstrap.com/docs/5.3/layout/containers/#fluid-containers) */
  fluid?: boolean;
}

export const ODSContainer: FC<ODSContainerProps> = ({
  children,
  className,
  fluid = false,
  ...props
}: ODSContainerProps) => {
  return (
    <div {...props} className={cx(fluid ? 'container-fluid' : 'container', className)}>
      {children}
    </div>
  );
};

export default ODSContainer;
